import {Pipe, PipeTransform} from '@angular/core';
import {TimeAgoPipe} from "ngx-moment";

@Pipe({
    name: 'customTimeAgo',
    pure: false,
    standalone: false,
  }
)
export class CustomTimeAgoPipe extends TimeAgoPipe implements PipeTransform {
  override transform(value: any, args?: any): any {
    let result = super.transform(value, args);

    // Thay "vài giây tới" thành "vài giây trước"
    result = result.replace(/vài giây tới|Vài giây tới/, 'vài giây trước');
    // Thay "một" hoặc "Một" thành "1"
    result = result.replace(/một|Một/, "1");
    return result;
  }
}
